import React, { useState, useEffect } from "react";



type Props = {
    links: { name: string, url: string }[];
}

const BaseFooter = ({links}: Props) => {

    return (
        <div className="footer-wrapper">
            <div className="footer-menu">
                <a href="https://viomitra.ru/"><img src="/main-images/footerLogo.svg" /></a>
                <ul>
                    {links.map(i =>
                        <li><a href={i.url}>{i.name}</a></li>
                    )}
                </ul>
            </div>
            <div className="footer-directions">
                <ul>
                    <li><a target="_blank" href="https://art.viomitra.ru/">ART. VIOMITRA</a></li>
                    <li><a target="_blank" href="https://invest.viomitra.ru/">INVEST. VIOMITRA</a></li>
                    <li><a target="_blank" href="https://bankrot.viomitra.ru/">BANKROT. VIOMITRA</a></li>
                    <li><a target="_blank" href="https://gov.viomitra.ru/">GOV. VIOMITRA</a></li>
                    <li><a target="_blank" href="https://dev.viomitra.ru/">DEV. VIOMITRA</a></li>
                    {/*<li><a target="_blank" href="https://china.viomitra.ru/">CHINA. VIOMITRA</a></li>*/}
                </ul>
            </div>
            <div className="footer-right">
                <div className="footer-top">
                    <div className="footer-links">
                        <div className="top-soc-links">
                            <a target="_blank" href="https://dzen.ru/mitra"><img src="/main-images/dzen.svg" alt="dzen" /></a>
                            <a target="_blank" href="https://vk.com/vio_mitra"><img src="/main-images/vkontakte.svg" alt="vk" /></a>
                            <a target="_blank" href="https://t.me/galakticamitra"><img src="/main-images/telegramm.svg" alt="telegram" /></a>
                            <a id="youtubeLink" target="_blank" href="https://www.youtube.com/@@Viomitra"><img src="/main-images/youtube.svg" alt="youtube" /></a>
                        </div>

                        <div className="bottom-contacts">
                            <a href="tel:+74951473765">+7 (495) 147-37-65</a>
                            <a href="mailto:support@viomitra.ru">support@viomitra.ru</a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>Используя сайт, вы&nbsp;подтверждаете <a target="_blank" href="https://realty.viomitra.ru/conf1">согласие на&nbsp;обработку персональных данных</a> и&nbsp;<a target="_blank" href="https://realty.viomitra.ru/conf1">политику конфиденциальности</a> ООО &laquo;МИТРА&raquo;</p>
                </div>
            </div>
        </div>
    )
}

export default BaseFooter;